// Chunk dimensions
export const CHUNK_SIZE = 16;
export const CHUNK_SIZE_SQ = CHUNK_SIZE * CHUNK_SIZE;
export const CHUNK_SIZE_CU = CHUNK_SIZE * CHUNK_SIZE * CHUNK_SIZE;

// World generation
export const WORLD_HEIGHT = 128;
export const WORLD_LIMIT = 1000;
export const RENDER_DISTANCE = 6;
export const SEA_LEVEL = 32;
export const TERRAIN_BASE = 40;
export const TERRAIN_AMPLITUDE = 30;

// Texture atlas
export const ATLAS_SIZE = 256;
export const TILE_SIZE = 16;
export const TILES_PER_ROW = ATLAS_SIZE / TILE_SIZE; // 16

// Physics
export const GRAVITY = -24.0;
export const JUMP_VELOCITY = 10.0;
export const PLAYER_SPEED = 5.0;
export const FLY_SPEED = 15.0;
export const SWIM_SPEED = 3.0;
export const PLAYER_WIDTH = 0.6;
export const PLAYER_HEIGHT = 1.75;
export const EYE_HEIGHT = 1.6;
export const TERMINAL_VELOCITY = -50;

// Game loop
export const TICK_RATE = 60;
export const TICK_DT = 1 / TICK_RATE;
export const MAX_TICKS_PER_FRAME = 5;

// Block interaction
export const REACH_DISTANCE = 6.0;

// Inventory
export const MAX_STACK_SIZE = 64;
export const HOTBAR_SIZE = 9;
export const STORAGE_SIZE = 27;

// Game modes
export const GameMode = {
  CREATIVE: 'creative',
  SURVIVAL: 'survival',
  SPECTATOR: 'spectator',
};

// Sky / fog colors
export const SKY_COLOR = 0x87CEEB;
export const NETHER_SKY_COLOR = 0x330808;
export const UNDERWATER_COLOR = 0x1E3C6E;

// Fog distances
export const OVERWORLD_FOG_NEAR = 50;
export const FOG_FAR_FACTOR = 0.9;
export const NETHER_FOG_NEAR = 10;
export const NETHER_FOG_FAR = 80;
export const UNDERWATER_FOG_NEAR = 5;
export const UNDERWATER_FOG_FAR = 30;

// Camera
export const CAMERA_FOV = 75;
export const CAMERA_NEAR = 0.1;
export const CAMERA_FAR_FACTOR = 1.5;

// Combat & damage
export const DAMAGE_COOLDOWN = 0.5;
export const LAVA_DAMAGE = 4;
export const SOUL_SAND_SLOWDOWN = 0.4;

// Hostile mobs
export const MAX_HOSTILE_MOBS = 15;
export const HOSTILE_SPAWN_INTERVAL = 5;
export const HOSTILE_DESPAWN_DISTANCE = 80;
export const HOSTILE_SPAWN_MIN_DIST = 25;
export const HOSTILE_SPAWN_RANGE = 30;

// Messages
export const TELEPORT_MSG_DURATION = 3;

// Furnace
export const SMELT_DURATION = 10;

// Farming
export const MAX_GROWTH_STAGE = 3;
export const CROP_GROWTH_TICK_INTERVAL = 5;
export const CROP_GROWTH_CHANCE = 0.2;
export const HYDRATION_RADIUS = 4;

// Sprint
export const SPRINT_SPEED_MULTIPLIER = 1.3;
export const SPRINT_FOV_BOOST = 10;

// Difficulty
export const Difficulty = {
  PEACEFUL: 'peaceful',
  EASY: 'easy',
  NORMAL: 'normal',
  HARD: 'hard',
};

export const DIFFICULTY_CONFIG = {
  [Difficulty.PEACEFUL]: { hostileMobs: false, mobDamageMult: 0,   hungerDrainMult: 0.5, starvationKills: false, passiveRegen: true,  maxHostileMobs: 0  },
  [Difficulty.EASY]:     { hostileMobs: true,  mobDamageMult: 0.5, hungerDrainMult: 0.75, starvationKills: false, passiveRegen: false, maxHostileMobs: 8  },
  [Difficulty.NORMAL]:   { hostileMobs: true,  mobDamageMult: 1.0, hungerDrainMult: 1.0, starvationKills: true,  passiveRegen: false, maxHostileMobs: 15 },
  [Difficulty.HARD]:     { hostileMobs: true,  mobDamageMult: 1.5, hungerDrainMult: 1.5, starvationKills: true,  passiveRegen: false, maxHostileMobs: 20 },
};

// End dimension
export const END_SKY_COLOR = 0x0A0012;
export const END_FOG_NEAR = 20;
export const END_FOG_FAR = 120;

// Seed
export const WORLD_SEED = 'minecraft-clone-phase1';
